import BackgroundFileTranslationsRequest from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/BackgroundFilesService/BackgroundFileTranslationsRequest";

export default class NatureSoundTranslateViewModel {
    langCode?: string = '';
	name?: string = '';
	id?: string = '';
    constructor(obj?: Partial<NatureSoundTranslateViewModel>) {
        if (obj) {
            Object.assign(this, obj);
        }
    }
    toServerModel(): BackgroundFileTranslationsRequest {
        const res = new BackgroundFileTranslationsRequest({
            LangCode: this.langCode,
            Name: this.name,
            Id: this.id || null
        });
        return res;
    }
}
